import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { LightboxService } from '../../components/lightbox/lightbox.service';

@Directive({
  selector: '[kLightboxTrigger]',
  standalone: true,
})
export class LightboxTriggerDirective {
  private elementRef = inject(ElementRef);
  private lightboxService = inject(LightboxService);

  kLightboxTrigger = input<string | undefined>();
  lightboxAlt = input<string | undefined>();

  @HostListener('click')
  onClick(): void {
    const imgElement = this.elementRef.nativeElement as HTMLImageElement;
    const imageUrl = this.kLightboxTrigger() || imgElement.src || imgElement.getAttribute('src');
    const altText = this.lightboxAlt() || imgElement.alt || '';

    if (imageUrl) {
      this.lightboxService.open({
        imageUrl,
        altText,
      });
    }
  }

  constructor() {
    const element = this.elementRef.nativeElement;
    element.style.cursor = 'pointer';
    element.style.userSelect = 'none';
  }
}
